
import React from 'react';
import { any, object, bool } from 'prop-types';
import { toUpper } from 'lodash';
import styled from 'styled-components';
import withTranslation from '../../../hoc/withTranslation';

const BaseTitle = styled.div`
    font-size: ${({ size = '14' }) => `${size}px`};
    color:${({ color = '#333333' }) => color};
    font-weight: ${({ fontWeight = 'bold' }) => fontWeight};
    min-width: 100%;
`;

const Title = ({ children, text, upperCase, ...props }) => (
    <BaseTitle {...props}>
        {children || (upperCase ? toUpper(text) : text)}
    </BaseTitle>
);

Title.propTypes = {
    children: any,
    style: object,
    text: any,
    upperCase: bool
};

Title.defaultProps = {
    style: {},
    text: '',
    upperCase: false
};

export default withTranslation(Title, ['children', 'text']);
